import { ChangeDetectionStrategy, Component, Input, OnInit, Self, TemplateRef, ViewChild } from "@angular/core";
import { MatSelect } from "@angular/material/select";
import { filterAllTruthyInTuple } from "core/rx-js";
import { combineLatest, distinctUntilChanged, filter, map, takeUntil } from "rxjs";
import { DataSourceControlService, OptionTemplateService } from "../data-source-utils";
import { FormControlService } from "../form-control.service";
import mapTemplateValue from "../form-rx-js/map-template-value";
import { ControlValueAccessorImpl } from "../ng-material-impl/control-value-accessor.impl";
import createControlValueAccessorProvider from "../utils/create-control-value-accessor-provider";
import { SelectFormControlService } from "./select-form-control.service";


@Component({
  selector: 'ss-select-form-control',
  templateUrl: './select-form-control.component.html',
  styleUrls: ['./select-form-control.component.css'],
  providers: [
    FormControlService,
    SelectFormControlService,
    createControlValueAccessorProvider(SelectFormControlComponent),
    { provide: DataSourceControlService, useExisting: SelectFormControlService },
    OptionTemplateService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectFormControlComponent extends ControlValueAccessorImpl<string> implements OnInit {

  @Input() optionTemplate!: TemplateRef<HTMLElement>

  @ViewChild(MatSelect)
  private _matSelect!: MatSelect

  readonly listItemsSubject = this._selectFormControlService.listItemsSubject;
  readonly dataSourceSubject = this._selectFormControlService.dataSourceSubject;
  readonly fetchedDataSubject = this._selectFormControlService.fetchedDataSubject;
  readonly valueExprSubject = this._selectFormControlService.valueExprSubject;
  readonly displayObs = this._selectFormControlService.displayObs;
  readonly displayExprSubject = this._selectFormControlService.displayExprSubject;
  readonly matTemplateTypeObs = this._selectFormControlService.matTemplateTypeObs;
  readonly dataObs = this._selectFormControlService.dataObs;
  readonly selectedItemSubject = this._selectFormControlService.selectedItemSubject;

  readonly hintObs = combineLatest([
    this._optionTemplateService.templateSubject,
    this.selectedItemSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      mapTemplateValue(),
      map((templateValue) => templateValue.description),
      filter(Boolean),
      map((description) => description),
      distinctUntilChanged()
    )


  constructor(
    @Self() private _selectFormControlService: SelectFormControlService,
    @Self() private _optionTemplateService: OptionTemplateService
  ) {
    super()

  }

  ngOnInit(): void {


  }

  ngAfterViewInit() {
    this._formControlService.htmlElementSubject.next(this._matSelect._elementRef.nativeElement);
    this._matSelect.valueChange
      .pipe(takeUntil(this._destroy))
      .subscribe((value) => this.selectedItemSubject.next(value))
  }

  getValueExpr(item: any) {
    const valueExpr = this.valueExprSubject.value;

    if (!valueExpr) {
      return item.value
    }

    return item[valueExpr];

  }

  getDisplayExpr(item: any) {
    const displayExpr = this.displayExprSubject.value;

    if (!displayExpr) {
      return item.text;
    }

    if (typeof displayExpr === 'function') {
      return displayExpr(item);
    }

    return displayExpr[item];

  }

  itemSelected(item: any) {

    this._selectFormControlService.selectedItemSubject.next(item)

  }

  readonly compareWith = (optionValue: any, value: any) => {


    return this.getValueExpr(optionValue) === value;
  }


}


